import { memo, useContext, useEffect } from 'react';
import DispatchContext from '../DispatchContext';
import StateContext from '../StateContext';

const Step = ({ children, name }) => {
  const { currentStep, steps } = useContext(StateContext);
  const dispatch = useContext(DispatchContext);

  useEffect(() => {
    dispatch({ action: 'ADD_STEP', payload: { name } });

    return () => {
      dispatch({ action: 'REMOVE_STEP', payload: { name } });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return steps[currentStep] === name ? children : null;
};

export default memo(Step);
